import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'fgb-facial-recognition-uploader-header',
  templateUrl: './facial-recognition-uploader-header.component.html',
  styleUrl: './facial-recognition-uploader-header.component.scss',
})
export class FacialRecognitionUploaderHeaderComponent {
  @Input() facialRecognitionHeading: string = '';
  @Input() facialRecognitionSubheading: string = '';
  @Input() stepCounter: number = 1;
  @Input() showBackButton: boolean = true;
  @Input() showCloseButton: boolean = false;
  @Output() setStep = new EventEmitter();
  @Output() previousStepChange = new EventEmitter();
  userKey: string = '';

  constructor(
    private router: Router,
    public activeModal: NgbModal,
    private route: ActivatedRoute
  ) {
    this.route.queryParamMap.subscribe((paramMap) => {
      this.userKey = paramMap.get('key') as string;
    });

    if (this.userKey) {
      this.showBackButton = false;
    } else {
      this.showBackButton = true;
    }
  }

  backButton() {
    if (this.stepCounter == 2 || this.stepCounter == 3) {
      this.previousStepChange.emit();
    } else if (this.stepCounter === 4) {
      this.setStep.emit(1);
    } else if (this.stepCounter === 5) {
      this.router.navigate(['account']);
    } else {
      this.router.navigate(['account']);
    }
  }

  close() {
    this.activeModal.dismissAll();
  }
}
